import React from 'react';
import config from 'config';
// Layouts
import { Dialog, DialogTitle, DialogContent, DialogActions } from 'layouts/Dialog';
// Components
import { Button } from 'components/Buttons';
// 
import QuizzesList from './QuizzesList';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  groupId: string;
  groupSlug: string;
  open: boolean;
  onClose: () => void;
}

const GroupQuizzesDialog:React.FC<Props> = ({
  // props
  groupId, groupSlug, open, onClose
}) => {
  const { t } = useTranslation();

  const handlePreview = () => {
    window.open(`${config.quizURL}/quiz-group/${groupSlug}`, '_blank');
  };

  return (
    <Dialog size="sm" open={open} onClose={onClose}>
      <DialogTitle title={t('dialogs.groupQuizzes.title')} onClose={onClose} />
      <DialogContent>
        <QuizzesList groupId={groupId} />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handlePreview}>
          {t('buttons.preview')}
        </Button>
        <Button
          onClick={onClose}
        >{t('buttons.close')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default GroupQuizzesDialog;
